import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useNotification } from '../../../../hooks'
import {
  ProfileResponsibleManagersWidget,
  ProfileResponsibleManagersWidgetItem,
} from '../../../Widget'
import { useRequestProfileContext } from '../../RequestProfile.hooks'
import { RequestProfileWidgetKey } from '../RequestProfileWidget.constants'

import { REQUEST_PROFILE_WIDGET_EDIT_MANAGER_FIELD_NAME_ASSIGNEES } from './RequestProfileWidgetResponsibleManagers.constants'
import {
  getInitialValues,
  getPayload,
  getRemainingManagersPayload,
} from './RequestProfileWidgetResponsibleManagers.utils'
import { SendInviteField } from './SendInviteField'

import * as styles from './RequestProfileWidgetResponsibleManagers.module.css'

function RequestProfileWidgetResponsibleManagers({ isSkeleton }) {
  const { t } = useTranslation()

  const { handleCloseModal, handleUpdateEntity, modal, requestData } =
    useRequestProfileContext()

  const { handleAddErrorNotification } = useNotification()

  const [deletingManagerId, setDeletingManagerId] = useState(null)

  const assignees = requestData?.assignees

  const canEditAssignee = Boolean(requestData?.permissions?.can_edit_assignee)

  function handleDeleteManager(managerId) {
    setDeletingManagerId(managerId)

    handleUpdateEntity(
      getRemainingManagersPayload({ assignees, removedManagerId: managerId }),
      'Notification.CommonTitleDeletedKey'
    )
      .catch(() => {
        handleAddErrorNotification('Error.CommonApiRequestFailKey')
      })
      .finally(() => {
        setDeletingManagerId(null)
      })
  }

  return (
    <ProfileResponsibleManagersWidget
      addButtonProps={{
        tooltipKey: 'Widget.ResponsibleManagersAddButtonTooltipKey',
      }}
      canEdit={canEditAssignee}
      contentContainerProps={{
        className: styles.managersContent,
      }}
      formProps={{
        AdditionalFormField: SendInviteField,
        additionalFormFieldProps: {
          requestId: requestData?.id,
        },
        fieldName: REQUEST_PROFILE_WIDGET_EDIT_MANAGER_FIELD_NAME_ASSIGNEES,
        formModal: modal,
        getPayload,
        initialValues: getInitialValues(assignees),
        placeholder: t('Widget.ResponsibleManagersPlaceholderKey'),
        onClose: handleCloseModal,
        onSubmit: handleUpdateEntity,
      }}
      isSkeleton={isSkeleton}
      items={assignees}
      listProps={{
        Item: ProfileResponsibleManagersWidgetItem,
        itemProps: {
          canDelete: canEditAssignee,
          deletingManagerId,
          onDelete: handleDeleteManager,
        },
        title: t('Widget.ResponsibleManagersListTitleKey', {
          count: assignees?.length,
        }),
        titleWrapperClassName: styles.itemsListTitleWrapper,
      }}
      title={t('Widget.ResponsibleManagersTitleKey')}
      widgetProps={{ qaName: RequestProfileWidgetKey.ASSIGNEES }}
    />
  )
}

export default RequestProfileWidgetResponsibleManagers
